import CustomTable from "../../../common/customTable/CustomTable";

const COLUMNS = [
	{
		accessorKey: "vesselConsumer",
		header: "Vessel Consumer",
		size: 160,
		enableSorting: false,
		enableColumnActions: false,
		enableColumnFilters: false,
	},
	{
		accessorKey: "monitoringMethod",
		header: "UK ETS Monitoring Method",
		size: 400,
		enableSorting: false,
		enableColumnActions: false,
		enableColumnFilters: false,
	},
	{
		accessorKey: "levelOfUncertainty",
		header: "UK ETS Level of Uncertainty ± (%)",
		size: 220,
		enableSorting: false,
		enableColumnActions: false,
		enableColumnFilters: false,
	},
];


const MonitoringMethodsTab = ({ monitoringMethods, loading = false }) => {


	return (
		<div className="p-2">
			<CustomTable
                renderTableData={monitoringMethods || []}
				columnsData={COLUMNS}
				customProps={{
					header: <strong>Monitoring Methods and Level of Uncertainty</strong>,
					enableToptoolbar: true,
					enableSort: false,
					enableColumnVirtualization: false,
					enableRowVirtualization: false,
					isLoading: loading,
					tableName: "monitoring-methods",
				}}
			/>
		</div>
	);
};

export default MonitoringMethodsTab;
